import moment from 'moment'

const convertToMinutesAndSeconds = time =>
	moment.utc(moment.duration(time).asMilliseconds()).format('HH:mm:ss').replace(/^0(?:0:0?)?/, '')

export {
	convertToMinutesAndSeconds,
}
